import React, { useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';

import { CardComponent, PageHeader, PageHeaderNav, SettingsForm } from 'components';
import { SuccessActionsDialog } from 'components/Dialogs';
import { useBusyProgressActions } from 'contexts/BusyProgressContext';
import { useServerErrorActions } from 'contexts/ServerErrorContext';
import { useSubmittingState } from 'hooks';
import { userAuthenticationSettingModel } from 'models';
import { ROUTES } from 'routes/constants';
import { getTWithPathKey } from 'utils';

import { Subtext } from '../AnalyticsProviders/GoogleTagManager/style';
import { Switch } from 'components/style';

const UserAuthenticationSettings = () => {
  const { handleServerError } = useServerErrorActions();
  const { withPageProgressHandler } = useBusyProgressActions();
  const { isSubmitting, withHandlingSubmittingState } = useSubmittingState();
  const [isActive, setIsActive] = useState(false);
  const [initialIsActive, setInitialIsActive] = useState(false);
  const [successActionMessages, setSuccessActionMessages] = useState<string[]>([]);

  const getT = getTWithPathKey('pages.settings.userAuthentication');

  useEffect(() => {
    getSetting();
  }, []);

  const getSetting = withPageProgressHandler(() =>
    userAuthenticationSettingModel
      .getSetting()
      .then(({ active }) => {
        setIsActive(active);
        setInitialIsActive(active);
      })
      .catch(handleServerError),
  );

  const handleSave = withHandlingSubmittingState(() =>
    userAuthenticationSettingModel
      .updateSetting({ active: isActive })
      .then(({ userAuthenticationSetting, success }) => {
        setIsActive(userAuthenticationSetting.active);
        setInitialIsActive(userAuthenticationSetting.active);
        setSuccessActionMessages(success);
      })
      .catch(handleServerError),
  );

  const renderSettingSwitch = () => (
    <Switch checked={isActive} onChange={() => setIsActive(prevState => !prevState)} />
  );

  return (
    <>
      <PageHeader title={getT('title')} backLink={ROUTES.settings}>
        <PageHeaderNav />
      </PageHeader>
      <SettingsForm
        isSaveButtonVisible={isActive !== initialIsActive}
        handleSave={handleSave}
        id="userAuthenticationSettings"
      >
        <CardComponent title={getT('cardTitle')} isLoading={isSubmitting} CardHeaderNav={renderSettingSwitch}>
          <Grid container>
            <Grid item xs={12}>
              <Subtext>{getT('description')}</Subtext>
            </Grid>
          </Grid>
        </CardComponent>
      </SettingsForm>
      <SuccessActionsDialog
        open={successActionMessages.length > 0}
        onClose={() => setSuccessActionMessages([])}
        messages={successActionMessages}
      />
    </>
  );
};

export default UserAuthenticationSettings;
